import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';
import { getAxiosCancelTokenSource } from "../../app.utils";

const businessesState = {
    baseURL: process.env.VUE_APP_BASE_URL,
    searchedAssets: [],
    showAssetId: null,
};

const businessesMutations = {
    [storeMutation.setSearchAssets]: (state, data) => {
        state.searchedAssets = data;
    },
    [storeMutation.setShowAssetId]: (state, data) => {
        state.showAssetId = data;
    },
    [storeMutation.resetShowAssetId]: (state) => {
        state.showAssetId = null;
    },
};

const businessesActions = {
    [storeAction.getSearchAssets]: wrapAction(
        storeAction.getSearchAssets, 
        ({ state, commit }, content) => {
            //handling race condition
            const requestSource = getAxiosCancelTokenSource();
            const requestObject = {
                actionName: storeAction.getSearchAssets,
                requestSource,
            };
            commit(storeMutation.handleCancelableRequest, requestObject, { root: true });
            return axios({
                url: `${state.baseURL}profiles/api/around-me/get-search-synonyms`,
                headers: getBasicHeaders(),
                method: 'POST',
                cancelToken: requestSource.token,
                data: content,
            })
                .then((response) => {
                    commit(storeMutation.removeCancelableRequest, storeAction.getSearchAssets, { root: true });
                    commit(storeMutation.setSearchAssets, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),

    [storeAction.getSearchLocations]: wrapAction(
    storeAction.getSearchLocations,
     ({ state, commit }, content) => {
        //handling race condition
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getSearchLocations,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });
        return axios({
            url: `${state.baseURL}profiles/api/around-me/get-location-suggestions`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: content,
            cancelToken: requestSource.token,
        })
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getSearchLocations, { root: true });
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
        },
    ),

    [storeAction.getSearchEstablishments]: wrapAction(
    storeAction.getSearchEstablishments, 
    ({ state, commit }, content) => {
        //handling race condition
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getSearchEstablishments,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

        return axios({
            url: `${state.baseURL}profiles/api/around-me/get-establishment-suggestions`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: content,
            cancelToken: requestSource.token,
        })
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getSearchEstablishments, { root: true });
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
        },
    ),
};

const businessesGetters = {
    [storeGetters.searchedAssets]: state => state.searchedAssets,
    [storeGetters.showAssetId]: state => state.showAssetId,
};

export default {
    namespaced: true,
    state: {
        initialState: businessesState,
        ...businessesState,
    },
    mutations: { ...businessesMutations },
    actions: { ...businessesActions },
    getters: { ...businessesGetters },
};
